import axios from 'axios';
import { apiKey, apiGetLessonRulesUrl } from '../../config';
import { logoutUser } from '../../utils/authHandling/logout-user';

export const getLessonRules = async function(id){
  let params = {
    apiKey: apiKey,
    token: sessionStorage.athenasToken,
    addressId: id
  }
  try{
    const response = await axios.get(apiGetLessonRulesUrl, { params });
    if(response.data.SessionValid){
      if(response.data.TransactionValid){
        //Session and transaction is valid, return the values
        //console.log("Get lesson rules response", response.data);
        return response.data.Rules[0];
      } else{
        alert(response.data.Messages);
      }
    } else{
      //session is not valid, user is sent to login
      alert('Session is not valid.');
      logoutUser();
    }
  } catch(error){
    alert(error.response.data.Messages);
  }
}